import React from 'react'
import './style.css'
const AboutInfo = () => {
  return (
    <>
    <div className='  AboutInfoMain' >
     <div className="AboutInfo Info signature_info">
       <h3 style={{fontWeight:'600'}}>Om Shahane</h3>
       <p>I am a Ahmednagar,Pathardi-based product designer with a focus on web design, illustration, a visual development. I have a diverse range of experience having worked across various fields and industries.</p>
    </div>
    
     
   </div>
    
    </>
  )
}

export default AboutInfo
